//
//
//
//
//
//
//
//
//
//
//

import mixin from './mixin'
export default {
    mixins: [mixin],
    computed: {
        page_style () {
            const [ width, height ] = this.home_bg_size
            return {
                backgroundImage: `url(${this.home_bg})`,
                backgroundSize: `100% auto`
            }
        },
        btn_style () {
            const [ x, y ] = this.home_btn_pos
            const [ width, height ] = this.home_btn_size
            return {
                top: `${x / 2}px`,
                left: `${y / 2 }px`,
                width: `${width / 2}px`,
                height: `${height / 2}px`
            }
        }
    },
    methods: {
        next (e) {
            this.$router.push({
                path: '/order_check/verify'
            })
        }
    }
}
